module.exports = __webpack_public_path__ + "static/img/wh-icon.245902fe.png";